import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ComicHero from "./components/ComicHero";
import ComicInfo from "./components/ComicInfo";
import ComicComments from "./components/ComicComments";
import { comics } from "@/mocks/comics";
import NotFound from "@/pages/NotFound";

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const comic = comics.find((c) => c.id === Number(id));

  if (!comic) {
    return <NotFound />;
  }

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: `${comic.title} - 韩漫网高清韩国漫画`,
    description: comic.description,
    author: {
      "@type": "Person",
      name: comic.author,
    },
    datePublished: "2024-01-15",
    dateModified: comic.updateTime,
    publisher: {
      "@type": "Organization",
      name: "韩漫网",
      url: "http://hongtongren.com/",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `http://hongtongren.com/article/${comic.id}`,
    },
  };

  const relatedComics = comics.filter((c) => c.id !== comic.id && c.category === comic.category).slice(0, 3);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
      <Navbar />
      <main>
        <div className="pt-16">
          <Breadcrumb
            items={[
              { name: "首页", href: "/" },
              { name: `${comic.category}漫画`, href: `/category/${comic.category === "武侠" ? "wuxia" : comic.category === "奇幻" ? "fantasy" : comic.category === "恋爱" ? "romance" : comic.category === "悬疑" ? "suspense" : comic.category === "古风" ? "historical" : "school"}` },
              { name: comic.title },
            ]}
          />
        </div>
        <ComicHero
          title={comic.title}
          author={comic.author}
          status={comic.status}
          latestChapter={comic.latestChapter}
          cover={comic.cover}
        />
        <ComicInfo
          description={comic.description}
          tags={comic.tags}
          views={comic.views}
          rating={comic.rating}
          status={comic.status}
          latestChapter={comic.latestChapter}
          updateTime={comic.updateTime}
          cover={comic.cover}
          title={comic.title}
        />
        <ComicComments />

        {relatedComics.length > 0 && (
          <section className="w-full py-14 md:py-20 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="mb-10 md:mb-14">
                <h2 className="text-2xl md:text-3xl font-black text-foreground-950"
                  style={{ fontFamily: "var(--font-heading)" }}>
                  同类型推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-2">
                  更多{comic.category}韩漫等你来发现
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-5">
                {relatedComics.map((rc) => (
                  <Link
                    key={rc.id}
                    to={`/article/${rc.id}`}
                    className="group"
                  >
                    <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                      <img
                        src={rc.cover}
                        alt={`${rc.title} - 韩漫网韩国漫画`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 text-center truncate whitespace-nowrap">
                      {rc.title}
                    </h3>
                    <div className="flex items-center justify-center gap-1.5 mt-1">
                      <span className="text-accent-500 font-bold text-xs">{rc.rating}</span>
                      <span className="text-foreground-400 text-xs">{rc.views}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </>
  );
}